import { Modal, Text, Button, Group, Stack } from '@mantine/core';
import { Transaction } from '../../types/transaction';

interface IgnoreTransactionModalProps {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    transaction?: Transaction | null;
}

export const IgnoreTransactionModal: React.FC<IgnoreTransactionModalProps> = ({
    opened,
    onClose,
    onConfirm,
    transaction,
}) => {
    return (
        <Modal opened={opened} onClose={onClose} title="Ignore Transaction" centered>
            <Stack gap="md">
                <Text>
                    Are you sure you want to ignore this transaction from your budget
                    calculations? You can undo this later by editing the transaction's
                    category.
                </Text>
                {transaction && (
                    <Text fw={500}>
                        {transaction.description} —{' '}
                        {new Intl.NumberFormat(undefined, {
                            style: 'currency',
                            currency: transaction.iso_currency_code || 'USD',
                        }).format(Math.abs(transaction.amount))}
                    </Text>
                )}
                <Group justify="flex-end">
                    <Button variant="default" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button color="yellow" onClick={onConfirm}>
                        Ignore
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
}; 